import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import Modal from './Modal';
import { authAPI } from '../../utils/api';
import { apiError } from '../../utils/helpers';

/** Every user can change their own password (v3.9: reachable from the sidebar, not only from the users page). */
export default function PasswordModal({ onClose }) {
  const { t } = useTranslation();
  const [f, setF] = useState({ old_password: '', new_password: '', again: '' });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    if (!f.old_password || !f.new_password) return toast.error(t('fill_required'));
    if (f.new_password.length < 6) return toast.error(t('pwd_too_short'));
    if (f.new_password !== f.again) return toast.error(t('pwd_mismatch'));
    setSaving(true);
    try { await authAPI.changePassword({ old_password: f.old_password, new_password: f.new_password }); toast.success(t('saved')); onClose(); }
    catch (e) { toast.error(apiError(e, t)); } finally { setSaving(false); }
  };
  return (
    <Modal title={t('change_password')} onClose={onClose} style={{ maxWidth: 400 }}
      footer={<><button className="btn btn-secondary" onClick={onClose}>{t('cancel')}</button><button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? t('loading') : t('save')}</button></>}>
      <div className="form-group"><label className="form-label">{t('old_password')}</label><input className="input" type="password" autoComplete="current-password" value={f.old_password} onChange={e => setF(x => ({ ...x, old_password: e.target.value }))} /></div>
      <div className="form-group"><label className="form-label">{t('new_password')}</label><input className="input" type="password" autoComplete="new-password" value={f.new_password} onChange={e => setF(x => ({ ...x, new_password: e.target.value }))} /></div>
      <div className="form-group" style={{ marginBottom: 0 }}><label className="form-label">{t('pwd_again')}</label><input className="input" type="password" autoComplete="new-password" value={f.again} onChange={e => setF(x => ({ ...x, again: e.target.value }))} /></div>
    </Modal>
  );
}
